import { useBuildVars, useSiteConfig } from '../config';
import GCP_US_ROUTES_CONFIG from './gcp-routes.json';
import GCP_EU_ROUTES_CONFIG from './gcp-routes-eu.json';
import { getSameOriginApiBasePath, useSameOriginApis } from './utils';

export function useApiBase() {
  const buildVars = useBuildVars();
  const siteConfig = useSiteConfig();
  const shouldUseSameOriginApis = useSameOriginApis();

  const GCPHost = buildVars.API_GCP_BASE;
  const EUGCPHost = buildVars.API_EU_GCP_BASE;
  const gcp_routes: string[] = getRoutes(
    GCP_US_ROUTES_CONFIG,
    buildVars.buildEnvironment,
    siteConfig.siteCode
  );
  const gcp_eu_routes: string[] = getRoutes(
    GCP_EU_ROUTES_CONFIG,
    buildVars.buildEnvironment,
    siteConfig.siteCode
  );

  return (route: string) => {
    if (route?.toLowerCase().startsWith('http')) {
      return '';
    }
    if (shouldUseSameOriginApis()) {
      return getSameOriginApiBasePath();
    }

    let apiBase = buildVars.API_BASE;
    if (GCPHost || EUGCPHost) {
      const isGCP =
        typeof buildVars.API_GCP_BASE === 'string' &&
        gcp_routes.some((path) => {
          return route.includes(path);
        });
      const isEUGCP =
        typeof buildVars['API_EU_GCP_BASE'] === 'string' &&
        gcp_eu_routes.some((path) => {
          return route.includes(path);
        });
      if (isEUGCP) {
        apiBase = buildVars['API_EU_GCP_BASE'];
      } else if (isGCP) {
        apiBase = buildVars.API_GCP_BASE;
      }
    }

    return apiBase;
  };
}

type RouteConfig = {
  countries: string[];
  environment: string;
  routes: string[];
};

function getRoutes(
  routesConfig: RouteConfig[],
  buildEnvironment: string,
  siteCode: string
) {
  return (
    routesConfig
      .filter(
        (r) =>
          (r.environment === '*' || r.environment === buildEnvironment) &&
          (r.countries.includes('*') || r.countries.includes(siteCode))
      )
      .flatMap((r) => r.routes) || []
  );
}
